import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';
import useCurrentUserId from './useCurrentUserId';
import useAllPaletteDbs from './useAllPaletteDbs';

import { deepCopy } from '../general';
import { TemplateListHashType } from '../components/AddCardDialog';

const usePaletteCardTemplateSet = () => {
  const userId = useCurrentUserId();
  const [paletteIds] = useAllPaletteDbs(userId);
  const cardTemplates = useSelector((state: RootState) => state.cardTemplateDb).cardTemplates;
  const relationPaletteCardTemplates = useSelector((state: RootState) => state.relationPaletteCardTemplateDb).relationPaletteCardTemplates;

  const [templateListHash, setTemplateListHash] = useState<TemplateListHashType>({});

  useEffect(() => {
    // set templateListHash
    const newTemplateList = deepCopy(templateListHash);
    paletteIds.forEach(id => {
      const rpcIds = Object.keys(relationPaletteCardTemplates).filter(rpcId => relationPaletteCardTemplates[rpcId].paletteId === id);
      rpcIds.sort((a, b) => {
        const rpcA = relationPaletteCardTemplates[a];
        const rpcB = relationPaletteCardTemplates[b];
        return rpcA.order - rpcB.order;
      })
      const templateIds = rpcIds.map(rpcId => relationPaletteCardTemplates[rpcId].cardTemplateId);
      const templates = templateIds.map((templateId, templateIx) => {
        return { ...cardTemplates[templateId], order: relationPaletteCardTemplates[rpcIds[templateIx]].order };
      });
      newTemplateList[id] = { ids: templateIds, values: templates };
    })
    setTemplateListHash(newTemplateList);
  }, [cardTemplates, relationPaletteCardTemplates])

  return templateListHash;
}

export default usePaletteCardTemplateSet;
